import { Formatter } from 'gf-ui';
import React, { useEffect, useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FaPaperclip } from 'react-icons/fa';

const Radio = ({ kid, item, domande, risposte_all, value, onChange }) => {
  const [visibile, mostra] = useState(false)

  const domanda = item.DESCRIZIONE;
  const linkFile = item.LINK_FILE;
  const linkDesc = item.LINK_DESC;
  const risposte = item.ARR_RISPOSTE;
  const mostraSe = item.ARR_RIFERIMENTI;

  const selVal = (val) => {
    onChange(kid, val)
  }

  useEffect(() => {
    if (mostraSe.length === 0) {
      mostra(true);
    } else {
      let mostraDomanda = false;
      Object.keys(mostraSe).forEach(idx => {
        const domanda_rif = mostraSe[idx];
        if (risposte_all.indexOf(domanda_rif.ID_MA_CSS_D_R) >= 0) {
          mostraDomanda = true;
        }
      })
      mostra(mostraDomanda)
    }
  }, [domande, mostraSe, risposte_all])

  useEffect(()=>{
    if(!visibile && !Formatter.isStringaVuota(value)){      
      onChange(kid, null)
    }
  }, [kid, onChange, value, visibile])

  return (
    <>
      {visibile && (
        <Form.Group className="mb-3 form-group">
          <div className="p-0 bg-white" style={{ border: `1px solid ${value ? 'green' : 'lightgrey'}`, borderRadius: '10px' }}>
            <div className={`form-control d-flex flex-row align-items-center justify-content-between w-100 ${(value !== undefined && value !== "") ? "is-valid" : ""}`} style={{ border: 'none', borderRadius: '10px' }}>
              <div className='form-label fw-bold' dangerouslySetInnerHTML={{ __html: domanda }} />
              {linkFile && (
                <a href={`/${linkFile}`} target="_blank" rel="noreferrer" className='btn btn-light text-primary'><strong>{linkDesc}</strong> <FaPaperclip /></a>
              )}
            </div>
            <div className='d-flex flex-row align-items-start justify-content-start'>
              <Row className='w-100'>
                {Object.keys(risposte).map((risposta, index) =>
                  <Col key={`radio_${risposte[risposta].ID_MA_CSS_D_R}`} xs={12} md={6} lg={4} xl={3}>
                    <Form.Check 
                      type="radio"
                      id={`risposta-${risposte[risposta].ID_MA_CSS_D_R}`}
                      name={`domanda-${kid}`}
                      label={`${risposte[risposta].DESCRIZIONE}`}
                      className="mx-4 mb-4"
                      required={Formatter.getBoolean(item.FLG_OBBLIGATORIA)}
                      checked={value.toString() === risposte[risposta].ID_MA_CSS_D_R.toString()}
                      onChange={() => selVal(risposte[risposta].ID_MA_CSS_D_R)}
                      style={{ fontSize: '24px' }}
                    />
                  </Col>
                )}
              </Row>
            </div>
          </div>
        </Form.Group>
      )}
    </>
  )
}

export default Radio;